import { Contract } from "@ethersproject/contracts";
import { accountLessProvider } from "./injected";
import punkAbi from "config/abi/punk.json";
import erc20Abi from "config/abi/erc20.json";
import marketplaceAbi from "config/abi/marketplace.json";
const getContract = (address: string, abi: any, web3) => {
  const provider = web3 ?? accountLessProvider;

  return new Contract(address, abi, provider);
};

export const getPunkContract = (web3) => {
  return getContract(process.env.REACT_APP_CONTRACT_ADDRESS, punkAbi, web3);
};

export const getERC20 = (web3) => {
  return getContract(
    process.env.REACT_APP_ERC20_CONTRACT_ADDRESS,
    erc20Abi,
    web3
  );
};

export const getMarketplaceContract = (web3) => {
  return getContract(
    process.env.REACT_APP_MARKETPLACE_CONTRACT,
    marketplaceAbi,
    web3
  );
};
